// const NZLO_prod_url = "connect.worldvision.org.nz"
import {SELECTED_SO_CODE_NZLO, 
    SELECTED_SO_CODE_FINO, 
    SELECTED_SO_CODE_AUTO,
    SELECTED_SO_CODE_JPNO} from "./soCode";

export const constants = {
    appName: "My World Vision",
    postLogoutUrl : window.location.origin.includes("localhost:3000") ? "http://localhost:3000/" : window.location.origin + "/mysponsorship/",
    currentOrigin : window.location.origin.includes("localhost:3000") ? "http://localhost:3000/" : window.location.origin + "/mysponsorship/",
    letterTrackingLevelsNonSRS : ["MESSAGE RECEIVED","APR","GREETINGS","CEW","SPONSORVISIT_THANKYOU","CHSN_IL","GN_THANKS_RECEIVED","INTRO_LETTER","CHILD_FAREWELL_RECEIVED","CHILD_INITIATED_RECEIVED","IL_KEEP_RECEIVED","SPON_REQUEST_RECEIVED","C-SO","C-SPO","C-PS","C-RMT","F-QRA"],
    guestRedirection :[
        {name: "France", value: "https://www.visiondumonde.fr/"},
        {name: "Nederland", value: "https://www.worldvision.nl/"},
        {name: "Austria", value: "https://www.worldvision.at/"},
        {name: "Finland", value: "https://www.worldvision.fi/"},
        {name: "New Zealand", value:"https://www.worldvision.org.nz"},
        {name: "Japan", value:"https://www.worldvision.jp/"},
    ],

  so_NZLO: {
    nzSSOCookieName : "access_token",
    app_url: "https://www.worldvision.org.nz/",
    socialMedia :[
        {name: "facebook", value: "https://www.facebook.com/WorldVisionNZ"},
        {name: "Youtube", value: "https://www.youtube.com/wvnz"},
        {name: "Twitter", value: "https://x.com/worldvisionnz"},
        {name: "Instagram", value: "https://www.instagram.com/worldvisionnz/"},
        {name: "Tiktok", value:"https://www.tiktok.com/@worldvisionnz"},
        {name: "bw", value:"https://shielded.co.nz/"},
        {name: "cid", value:"https://www.cid.org.nz/code-of-conduct/about/"},
        {name: "pwc", value:"https://www.pwc.co.nz/"},
        {name: "about", value:"https://www.worldvision.org.nz/about/"},
        {name: "career", value:"https://www.worldvision.org.nz/about/careers/"},
        {name: "terms", value:"https://www.worldvision.org.nz/about/contact-us/terms-and-conditions"},
        {name: "safe", value:"https://www.worldvision.org.nz/about/contact-us/terms-and-conditions/#safeguarding"},
        {name: "contactus", value:"https://www.worldvision.org.nz/about/contact-us/"},

    ],
},
  regions:[
        {
            "id": 1,
            "name": "East Africa",
            "long": "EASTAFRICA",
            "short": "EAR",
        },
        {
            "id": 2,
            "name": "Southern Africa",
            "long": "SOUTHERNAFRICA",
            "short": "SAR"
        },
        {
            "id": 3,
            "name": "West Africa",
            "long": "WESTAFRICA",
            "short": "WAR"
        },
        {
            "id": 4,
            "name": "East Asia",
            "long": "EASTASIA",
            "short": "EAS"
        },
        {
            "id": 5,
            "name": "Latin America & the Caribbean",
            "long": "LATINAMERICACARIBBEAN",
            "short": "LAC"
        },
        {
            "id": 6,
            "name": "Middle East & Eastern Europe",
            "long": "MEER",
            "short": "MEER"
        },
        {
            "id": 7,
            "name": "South Asia Pacific",
            "long": "SOUTHASIA",
            "short": "SAP"
        }
    ],
    stations: [
        {
            id: "3",
            name: "education&training"
        },
        {
            id: "5",
            name: "health&nutrition"
        },
        {
            id: "4",
            name: "water&livelihoods"
        },
        {
            id: "6",
            name: "wellbeing&development"
        }
    ],
    sponsorshipUrlMap: {
        [SELECTED_SO_CODE_NZLO]: "https://www.worldvision.org.nz/about-child-sponsorship/",
        [SELECTED_SO_CODE_FINO]: "https://www.worldvision.fi/lahjoita/ryhdy-kummiksi/miten-kummius-toimii/"
    },
    faqUrlMap: {
        [SELECTED_SO_CODE_NZLO]: "https://www.worldvision.org.nz/about/faqs/?category=childsponsorship&page=1",
        [SELECTED_SO_CODE_FINO]: "https://www.worldvision.fi/meista/usein-kysytyt-kysymykset/#kummius"
    },
    worldVisionMap: {
        [SELECTED_SO_CODE_NZLO]: "https://www.worldvision.org.nz/",
        [SELECTED_SO_CODE_FINO]: "https://www.worldvision.fi/"
    },
    eLetterMinCharacterLimit: {
        [SELECTED_SO_CODE_NZLO]: 200,
        [SELECTED_SO_CODE_FINO]: 200,
        [SELECTED_SO_CODE_AUTO]: 200,
        [SELECTED_SO_CODE_JPNO]: 100
    },
}